// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout-header.app-header {
  display: flex;
  align-items: center;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  color: black;
  background-color: #fff;
  z-index: 1001;
  padding: 0 24px;
}
.ant-layout-header.app-header .menu-bar {
  margin-left: auto;
}
.app-header-avatar {
  cursor: pointer;
}
.app-header-user-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 300px;
}
.app-header-profile {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 24px;
}
.app-header-profile .name {
  font-weight: bold;
  margin-top: 12px;
}
.app-header-profile .username {
  font-size: 12px;
  margin-top: 3px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/@nackle+studio-tools@1.9.9_@types+react@18.3.12_antd@5.24.6_date-fns@2.30.0_moment@2.30.1_rea_phmwef3nwavhog6egt6kd254om/node_modules/@nackle/studio-tools/dist/components/app-header/app-header.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;AACJ;AARA;EAUQ,iBAAA;AACR;AAGA;EACI,eAAA;AADJ;AAIA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAFJ;AAKA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;AAHJ;AADA;EAOQ,iBAAA;EACA,gBAAA;AAHR;AALA;EAYQ,eAAA;EACA,eAAA;AAJR","sourcesContent":[".ant-layout-header.app-header {\n    display: flex;\n    align-items: center;\n    box-shadow: 2px 0 6px rgba(0,21,41,.35);\n    color: black;\n    background-color: #fff;\n    z-index: 1001;\n    padding: 0 24px;\n\n    .menu-bar {\n        margin-left: auto;\n    }\n}\n\n.app-header-avatar {\n    cursor: pointer;\n}\n\n.app-header-user-menu {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    min-width: 300px;\n}\n\n.app-header-profile {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding: 24px;\n\n    .name {\n        font-weight: bold;\n        margin-top: 12px;\n    }\n\n    .username {\n        font-size: 12px;\n        margin-top: 3px;\n    }\n}\n\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
